import $ from 'jquery';
import depensesCaisse from '@/api/comptabilite/_depenses-caisse';
import { jouer, nouveautes, sonAJouer } from '@/utils/sons-alertes';
import ReglagesSons from '@/components/reglages-sons';
import { rdvWebActif } from '@/utils/rdv-web';

const ROLES_DEMANDES_SITES = ['ROLE_CAISSIERE', 'ROLE_ACCUEIL', 'ROLE_CAISSIERE_INTERMITENT']

export default {
    name: 'sidebar',
    components: { ReglagesSons },
    props: [],
    data () {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            openModule: null,
            depenses_a_valider: 0,
            // Demandes de rendez-vous des sites en attente (04/10/2026) ; pastilles relues chaque minute.
            demandes_sites: 0,
            minuteur_badges: null,
            // Sons des alertes : compteurs de la dernière actualisation (null = pas encore de référence, aucun son).
            reference_sons: null,
            badges_en_cours: null,

            coupon_filter: {
                month: "",
                one_date: "",
                from_date: "",
                to_date: "",
                is_all: true
            }
        }
    },

    watch: {
        discount_observer() {
            this.countCoupon(this.coupon_filter)
        },

        cancellation_observer() {
            this.getCancellationRequest()
        },

        activeRole() {
            if (this.activeRole.nom == 'ROLE_ADMINISTRATEUR') {
                this.countCoupon(this.coupon_filter)
                this.getCancellationRequest()
            }
            this.compterDepensesAValider()
            this.$nextTick(this.syncOpenModule)
            this.reference_sons = null
            this.rafraichirBadges()
        },

        '$route.path'() {
            this.syncOpenModule()
            this.compterDepensesAValider()
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
        
        activeRole(){
            return this.$store.getters['activeRole'];
        },

        discount_observer() {
            return this.$store.getters["discount_observer"];
        },

        global_discount_number() {
            return this.$store.getters["global_discount_number"];
        },

        cancellation_observer() {
            return this.$store.getters["cancellation_observer"];
        },

        global_cancellation_request() {
            return this.$store.getters["global_cancellation_request"];
        },

        // Alertes sonores proposées au poste selon le rôle.
        alertesSons() {
            const role = (this.activeRole || {}).nom
            if (role === 'ROLE_ADMINISTRATEUR') return ['validations']
            return rdvWebActif() && ROLES_DEMANDES_SITES.indexOf(role) >= 0 ? ['demandes_sites'] : []
        },

        navigationModules() {
            const role = (this.activeRole || {}).nom
            const admin = 'ROLE_ADMINISTRATEUR'
            const accountant = 'ROLE_COMPTABLE'
            const treasury = 'ROLE_TRESORERIE'
            return [
                { key: 'treasury', label: 'Trésorerie et caisse', icon: 'ic-cash-flow', items: [
                    { label: 'Trésorerie', to: '/tresorerie', icon: 'ic-cash-flow', roles: [admin, treasury] },
                    { label: 'Journal de caisse', to: '/journal-caisse', icon: 'ic-cash-book', roles: [admin, accountant, treasury] },
                    { label: 'Dotation', to: '/dotation', icon: 'ic-dotation', roles: [treasury] },
                    { label: 'Dettes', to: '/dettes', icon: 'ic-hand-refund', roles: [treasury] }
                ] },
                { key: 'accounting', label: 'Comptabilité', icon: 'ic-income', items: [
                    { label: 'Produits', to: '/produits', icon: 'ic-income', roles: [admin, accountant] },
                    { label: 'Charges', to: '/charges', icon: 'ic-expense', roles: [admin, accountant] },
                    { label: 'Créances', to: '/creance', icon: 'ic-claim', roles: [admin, accountant] },
                    { label: 'Ligne budgétaire', to: '/ligne-budgetaire', icon: 'ic-document', roles: [admin] }
                ] },
                { key: 'requests', label: 'Demandes et validations', icon: 'ic-authorization', items: [
                    { label: 'Demandes d’annulation', to: '/demande-annulation', icon: 'ic-cancellation', roles: [admin], badge: 'cancellation' },
                    { label: 'Demandes d’autorisation', to: '/demande-autorisation', icon: 'ic-authorization', roles: [admin], badge: 'cancellation' },
                    { label: 'Remises', to: '/coupons', icon: 'ic-coupon', roles: [admin], badge: 'discount' },
                    // Dépenses faites par la caisse, validées après coup comme les remises (l'administrateur valide).
                    { label: 'Dépenses de caisse', to: '/depenses-caisse', icon: 'ic-expense', roles: [admin, accountant, treasury], badge: 'expense' }
                ] },
                { key: 'administration', label: 'Administration', icon: 'ic-cog', items: [
                    { label: 'Banque', to: '/banque', icon: 'ic-bank', roles: [admin] },
                    { label: 'Contrôle des sorties', to: '/portail/sorties', icon: 'ic-shield', roles: [admin] }
                ] }
            ].map(module => ({ ...module, items: module.items.filter(item => item.roles.includes(role)) }))
                .filter(module => module.items.length)
        }
    },

    mounted () {
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;
        }

        this.rafraichirBadges()
        this.syncOpenModule()
        this.minuteur_badges = setInterval(this.rafraichirBadges, 60000)
        document.addEventListener('visibilitychange', this.rafraichirBadges)
    },

    beforeDestroy () {
        clearInterval(this.minuteur_badges)
        document.removeEventListener('visibilitychange', this.rafraichirBadges)
    },

    methods: {
        // Toutes les pastilles du menu : au chargement, chaque minute et au retour sur l'onglet.
        async rafraichirBadges() {
            if (typeof document !== 'undefined' && document.hidden) return
            const role = (this.activeRole || {}).nom
            if (this.badges_en_cours === role) return
            this.badges_en_cours = role
            await Promise.all([
                this.countCoupon(this.coupon_filter),
                this.getCancellationRequest(),
                this.compterDepensesAValider(),
                this.compterDemandesSites()
            ].map(promesse => Promise.resolve(promesse).catch(() => null)))
            if (this.badges_en_cours === role) this.badges_en_cours = null
            if (role !== (this.activeRole || {}).nom) return
            this.sonnerNouveautes()
        },

        // Un son (le plus urgent) seulement si un compteur a augmenté depuis la dernière actualisation.
        sonnerNouveautes() {
            const actuel = this.compteursSons()
            const type = sonAJouer(nouveautes(this.reference_sons, actuel))
            this.reference_sons = actuel
            if (type) jouer(type)
        },

        compteursSons() {
            const alertes = this.alertesSons
            return {
                validations: alertes.indexOf('validations') >= 0 ? this.badgeValue('cancellation') + this.badgeValue('discount') + this.badgeValue('expense') : 0,
                demandes_sites: alertes.indexOf('demandes_sites') >= 0 ? Number(this.demandes_sites) || 0 : 0
            }
        },

        // Pastille « Rendez-vous » : demandes faites en ligne sur le site, en attente (Accueil, Caisse).
        async compterDemandesSites() {
            const role = (this.activeRole || {}).nom
            if (!rdvWebActif() || ROLES_DEMANDES_SITES.indexOf(role) < 0) { this.demandes_sites = 0; return }
            try {
                const api = (await import('@/api/clinique/_rendez_vous')).default
                const acces = await api.access()
                const reponse = await api.demandesSites({ status: 'en_attente', page: 1 }, acces.access_token)
                this.demandes_sites = Number(reponse && reponse.total) || 0
            } catch (erreur) {
                // Demandes en ligne non activées ou indisponibles : la pastille garde sa dernière valeur
                // (une coupure passagère ne doit pas faire sonner au retour).
            }
        },

        countCoupon(data) {
            return this.$store.dispatch('countDiscount', data)
        },

        getCancellationRequest() {
            return this.$store.dispatch('countCancellationRequest')
        },

        // Pastille « Dépenses de caisse » : dépenses à valider (seul l'administrateur les valide).
        compterDepensesAValider() {
            if (((this.activeRole || {}).nom) !== 'ROLE_ADMINISTRATEUR') { this.depenses_a_valider = 0; return null }
            // Erreur passagère : la pastille garde sa dernière valeur.
            return depensesCaisse.countToValidate()
                .then(reponse => { this.depenses_a_valider = Number(reponse && reponse.data && reponse.data.a_valider) || 0 })
                .catch(() => null)
        },

        badgeValue(key) {
            if (key === 'cancellation') return Number(this.global_cancellation_request) || 0
            if (key === 'discount') return Number(this.global_discount_number) || 0
            if (key === 'expense') return Number(this.depenses_a_valider) || 0
            return 0
        },

        moduleBadge(module) {
            if (module.key !== 'requests') return 0
            return this.badgeValue('cancellation') + this.badgeValue('discount') + this.badgeValue('expense')
        },

        moduleIsActive(module) {
            const path = (this.$route && this.$route.path) || ''
            return module.items.some(item => path === item.to || path.startsWith(item.to + '/'))
        },

        syncOpenModule() {
            const active = this.navigationModules.find(module => this.moduleIsActive(module))
            this.openModule = active ? active.key : null
        },

        toggleModule(key) {
            this.openModule = this.openModule === key ? null : key
        },

        onSidebarItemClick(e) {
            // A module toggle expands the menu without closing the mobile sidebar.
            const $target = $(e.target);
            if ($target.closest('.sidebar-module__toggle').length) return;

            // Only react to clicks within an <li> inside the menu
            if (!$target.closest('li').length) return;

            this.closeSidebar();
        },

        closeSidebar() {
            const sidebar = $('#sdbr');
            if (sidebar.hasClass('shw-sdbar')) {
                sidebar.removeClass('shw-sdbar');
                // Trigger toggleSidebar in navbar to update the icon state
                this.$root.$emit('closeSidebar');
            }
        }
    }
}
